module.exports = __webpack_public_path__ + "static/media/elica.649b4f0e.png";